import React from 'react';

function BtnSubmitTest(props) {
  return <button 
	  className={'btn btn-' + (props.filledInAllAnswers?'':'disabled')}
	  onClick={props.completeTest}>Skicka in dina svar</button>;
}

export default BtnSubmitTest;



// WEBPACK FOOTER //
// ./src/components/BtnSubmitTest.js